import axios from '@axios'

export default {
    index({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/audit', payload)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        }
        )
    },
}